import React from 'react';

import OnboardingContainer from '../../features/Onboarding/Onboarding';

const SponsorOnboardingPage: React.FC = () => <OnboardingContainer />;

export default SponsorOnboardingPage;
